<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>{{ title }}</h2>
    </header>
    <div class="p-0 p-md-4">
      <div class="row">
        <div class="col-12 col-lg-6 col-md-8 col-sm-10">
          <h3 class="mt-3 mb-5">Account Statements Download</h3>
          <div class="">
            <div
              v-for="document in statementList"
              :key="document"
              @click.prevent="
                PrintStatement(document.type, ContactNo, document.code)
              "
              class="
                cursor
                w3-block
                size16
                w3-border
                my-3
                py-2
                px-4
                w3-text-black w3-hover-red w3-hover-text-white
                no-hover-underline
                w3-left-align
              "
            >
              <i class="bx bxs-file-archive"></i> Request
              {{ document.code }} Fund Statement
            </div>
            <!-- <button
              @click.prevent="PrintStatement('hiw', ContactNo, 'hiw')"
              class="
                w3-block
                size16
                w3-border
                my-2
                py-2
                px-4
                w3-hover-red w3-hover-text-white
                no-hover-underline
                w3-left-align
              "
            >
              <i class="bx bxs-file-archive"></i> HIW STATEMENT
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template> 
<script>
import { ref, onBeforeMount, computed } from "vue";
import { useStore } from "vuex";
import usePrintStatement from "@/composables/use-print-statement";

export default {
  components: {},

  setup() {
    const title = ref("Account Statements");
    const store = useStore();
    // const Email = computed(() => store.state.userData.EMail);
    const ContactNo = computed(() => store.state.userData.contactNo);
    const DashBoard_Data = computed(() => store.state.DashBoard_Data);
    const fetching = computed(() => store.state.fetching.DashBoard_Data);

    if (!DashBoard_Data.value?.length) {
      store.dispatch("Dashboard");
    }
    const { getStatement, fetchingStatement, spinner } = usePrintStatement();
    const PrintStatement = (type, ContactNo, fundType) =>
      getStatement(type, ContactNo, fundType);

    const InvestmentCodes = ref([]);
    for (let inv in DashBoard_Data.value) {
      let Code = DashBoard_Data.value[inv].FundCode;
      InvestmentCodes.value.push(Code);
    }

    const statementList = ref([]);
    InvestmentCodes.value.forEach((code) => {
      let type =
        code.toLowerCase() == "fif" || code.toLowerCase() == "halal"
          ? "fifhalal"
          : code;
      statementList.value.push({ code, type });
    });

    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });
    return {
      title,
      ContactNo,
      PrintStatement,
      spinner,
      fetching,
      fetchingStatement,
      statementList,
      InvestmentCodes,
    };
  },
};
</script>
